// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../assets/stylesheets/variables.scss\"","seaweedColor":"#2daf92","container":"CanvasEditableText_container__15-EF"};